/* AIOO Printcase: CTA click tracking + mobile sticky order bar. No dependencies.
   Markup contract:
     a[data-pc-cta="<placement>"]   outbound printcase.lv link, fires `printcase_cta_click` on click
     #pc-sticky                     mobile bar, shown while the hero CTA is above the viewport and the final CTA is not reached yet
     [data-pc-sticky-trigger]       hero CTA row (bar appears after it scrolls out)
     [data-pc-sticky-end]           final CTA block (bar hides when it comes into view)
   Safe to include more than once per page (promo strips on other pages load it too). */
(function () {
  'use strict';
  if (window.__aiooPrintcaseBound) return;
  window.__aiooPrintcaseBound = true;

  /* Same sink as the filter events: AIOO_trackUxEvent (assets/aioo-ux.js) feeds dataLayer, gtag, fbq and Clarity.
     Fallback to a plain dataLayer push if that file is not there. */
  function track(placement, href) {
    var data = {
      location: placement,
      link_url: String(href || '').split('?')[0],
      language: document.documentElement.lang || '',
      transport_type: 'beacon'
    };
    try {
      if (typeof window.AIOO_trackUxEvent === 'function') {
        window.AIOO_trackUxEvent('printcase_cta_click', data);
      } else if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: 'printcase_cta_click' }, data));
      }
    } catch (e) { /* non-blocking */ }
  }

  function onClick(e) {
    var a = e.target && e.target.closest ? e.target.closest('a[data-pc-cta]') : null;
    if (a) track(a.getAttribute('data-pc-cta'), a.href);
  }
  document.addEventListener('click', onClick);
  document.addEventListener('auxclick', onClick);

  /* ---- Sticky order bar (phones) ---------------------------------------- */
  function initSticky() {
    var bar = document.getElementById('pc-sticky');
    var trigger = document.querySelector('[data-pc-sticky-trigger]');
    if (!bar || !trigger || !('IntersectionObserver' in window)) return;
    var end = document.querySelector('[data-pc-sticky-end]');
    var heroGone = false;
    var endReached = false;
    var root = document.documentElement;

    function apply() {
      var on = heroGone && !endReached;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      root.classList.toggle('pc-sticky-on', on);
    }
    new IntersectionObserver(function (entries) {
      var r = entries[0];
      heroGone = !r.isIntersecting && r.boundingClientRect.top < 0;
      apply();
    }).observe(trigger);
    if (end) {
      new IntersectionObserver(function (entries) {
        var r = entries[0];
        endReached = r.isIntersecting || r.boundingClientRect.top < 0;
        apply();
      }).observe(end);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky);
  else initSticky();
})();
